import { createPublicClient, http } from 'viem';
import { CONFIG } from '../config';
import { apechain } from './wagmi';

export const publicClient = createPublicClient({
  chain: apechain,
  transport: http(CONFIG.RPC_URL)
});